export default {
  methods: {
    directionValue(row) {
      if (row.movement_direction != null) {
        return Number(row.movement_direction);
      }
      if (row.action_type && row.action_type.direction != null) {
        return Number(row.action_type.direction);
      }
      return 0;
    },
    directionSign(row) {
      const direction = this.directionValue(row);
      if (direction > 0) {
        return "+";
      }
      if (direction < 0) {
        return "−";
      }
      return "±";
    },
    directionColor(row) {
      const direction = this.directionValue(row);
      if (direction > 0) {
        return "success";
      }
      if (direction < 0) {
        return "error";
      }
      return "grey darken-1";
    },
    directionIcon(row) {
      const direction = this.directionValue(row);
      if (direction > 0) {
        return "mdi-arrow-down-bold";
      }
      if (direction < 0) {
        return "mdi-arrow-up-bold";
      }
      return "mdi-swap-horizontal";
    },
    actionTypeName(row) {
      return row.action_type ? row.action_type.name : "-";
    },
    actionCategoryLabel(category) {
      const key = `STOCK.RECEIPTS.ACTION_CATEGORIES.${category}`;
      return this.$te(key) ? this.$t(key) : category;
    },
    dealLabel(row) {
      const deal = row.deal;
      if (!deal) {
        return "-";
      }
      if (deal.code && deal.name) {
        return `${deal.code} — ${deal.name}`;
      }
      return deal.name || deal.code || "-";
    },
    counterpartyLabel(row) {
      const company = row.source_company || row.destination_company;
      if (!company) {
        return "-";
      }
      return company.label || company.name || "-";
    },
    warehouseLabel(row) {
      const direction = this.directionValue(row);
      const warehouse =
        direction < 0 ? row.source_warehouse : row.destination_warehouse;
      const fallback = row.destination_warehouse || row.source_warehouse;
      const wh = warehouse || fallback;
      if (!wh) {
        return "-";
      }
      if (wh.code && wh.name) {
        return `${wh.code} — ${wh.name}`;
      }
      return wh.name || wh.code || "-";
    },
    receiptStatusColor(status) {
      const map = {
        draft: "grey",
        expected: "orange",
        finalized: "success",
        reversed: "purple",
        cancelled: "error",
      };
      return map[status] || "grey";
    },
    receiptStatusLabel(status) {
      const key = `STOCK.STATUSES.RECEIPT.${(status || "").toUpperCase()}`;
      return this.$te(key) ? this.$t(key) : status;
    },
    formatMovementMoney(value, currency) {
      return `${Number(value || 0).toFixed(2)} ${currency || ""}`.trim();
    },
    formatFinancialValue(value, currency) {
      if (value == null || value === "") {
        return "-";
      }
      return this.formatMovementMoney(value, currency);
    },
    movementMarginPct(row) {
      if (!this.isOutboundMovement(row)) {
        return "-";
      }
      if (row.margin_pct != null) {
        return `${Number(row.margin_pct).toFixed(2)}%`;
      }
      if (row.total_margin_net != null && row.total_net) {
        const pct = (Number(row.total_margin_net) / Number(row.total_net)) * 100;
        return `${pct.toFixed(2)}%`;
      }
      return "-";
    },
    isOutboundMovement(row) {
      return this.directionValue(row) < 0;
    },
    isInboundMovement(row) {
      return this.directionValue(row) > 0;
    },
    marginTextClass(value) {
      if (value == null || Number(value) === 0) {
        return "";
      }
      return Number(value) > 0 ? "success--text" : "error--text";
    },
  },
};
